export const JOB_STAGES = [
  "Quote",
  "Template",
  "Fabrication",
  "Polish & QC",
  "Install",
  "Complete",
];

export const STAGE_STYLE = {
  Quote: "bg-zinc-500/25 text-zinc-100 border-zinc-400/50",
  Template: "bg-purple-500/25 text-purple-100 border-purple-400/50",
  Fabrication: "bg-yellow-500/25 text-yellow-100 border-yellow-400/50",
  "Polish & QC": "bg-orange-500/25 text-orange-100 border-orange-400/50",
  Install: "bg-blue-500/25 text-blue-100 border-blue-400/50",
  Complete: "bg-emerald-500/25 text-emerald-100 border-emerald-400/50",
};

export const STAGE_DOT = {
  Quote: "bg-zinc-400",
  Template: "bg-purple-400",
  Fabrication: "bg-yellow-400",
  "Polish & QC": "bg-orange-400",
  Install: "bg-blue-400",
  Complete: "bg-emerald-400",
};

export const StageBadge = ({ stage, testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-zinc-200"
  >
    <span
      className={`h-2.5 w-2.5 shrink-0 rounded-full ${STAGE_DOT[stage] || STAGE_DOT.Quote}`}
    />
    {stage}
  </span>
);
